import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { SpringShareFormEmbedEntry } from "frontend/contentful/schema/blocks";
import {
  IFrameFormEmbed,
  IFrameFormEmbedProps,
} from "design-system/components/blocks/iframe-form-embed/iframe-form-embed";

export const ContentfulSpringShareFormEmbed =
  createContentfulComponent<SpringShareFormEmbedEntry>(({ entry }) => {
    const props: IFrameFormEmbedProps = {
      embedSourceUrl: entry.fields.embedSourceUrl,
      embedSourceTitle: entry.fields.embedSourceTitle,
      height: entry.fields.height,
      align: entry.fields.alignment,
      formSource: "springshare",
    };
    return <IFrameFormEmbed {...props} />;
  });
